function SummerHolidays() {
    return (
        <div className="bg-white py-10">
            <div className="flex flex-col w-4/5 mx-auto gap-y-4">
                <div className="text-center">
                    <p className="text-3xl font-bold text-primary-light">FERMETURE ESTIVALE</p>
                    <p className="text-2xl text-primary-light">DU 25 JUILLET </p>
                    <p className="text-2xl text-primary-light">AU 8 AOÛT</p>
                </div>
                <div className="text-center">
                    <p className="text-xl">AU BESOIN, VOUS POUVEZ JOINDRE LES COURTIERS :</p>
                </div>
                <div className="flex flex-col md:flex-row justify-between gap-y-2 md:w-3/5 mx-auto text-xl">
                    <div>
                        <p className="underline font-bold">TÉLÉPHONE ET WHATSAPP:</p>
                        <p>DAVID FOTI: 078 870 8008</p>
                        <p>FABIENNE FOTI: 078 870 1077</p>
                        <p>SERHAT POLAT: 078 654 9263</p>
                        <p>GIANNI DEIANA: 079 588 2250</p>
                    </div>
                    <div>
                        <p className="underline font-bold">MAIL:</p>
                        <p>david@foti-immo.ch</p>
                        <p>fabienne@foti-immo.ch</p>
                        <p>serhat@foti-immo.ch</p>
                        <p>gianni@foti-immo.ch</p>
                    </div>
                </div>
                <div className="text-center">
                    <p className="text-2xl font-bold text-primary-light">TOUTE L'ÉQUIPE VOUS SOUHAITE UN TRÈS BEL ÉTÉ !</p>
                </div>
            </div>
        </div>
    );
}

export default SummerHolidays;
